<div #winRef class="sticky-window" [style.background]="note.color" [style.color]="textColor" (mousedown)="onWindowMousedown()">

  <div class="sticky-window__drag" (mousedown)="startDrag($event)">
    <span class="drag-dots">
      <i></i><i></i><i></i>
      <i></i><i></i><i></i>
    </span>
  </div>

  <div class="sticky-window__header">
    <input
      class="sticky-window__title"
      [(ngModel)]="localTitle"
      (ngModelChange)="onContentChange()"
      placeholder="Title..." />
    <div class="sticky-window__actions">
      <div class="color-picker-wrap">
        <button class="btn-icon" (click)="showColorPicker = !showColorPicker" matTooltip="Change color" matTooltipPosition="left">
          <mat-icon>palette</mat-icon>
        </button>
        <div class="color-picker" *ngIf="showColorPicker">
          <button
            *ngFor="let c of colors"
            class="color-dot"
            [style.background]="c"
            [class.active]="c === note.color"
            (click)="pickColor(c)">
          </button>
        </div>
      </div>
      <button class="btn-icon" (click)="close()" matTooltip="Minimize" matTooltipPosition="left">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <textarea
    class="sticky-window__body"
    [(ngModel)]="localContent"
    (ngModelChange)="onContentChange()"
    placeholder="Jot down a reminder, follow-up, or quick thought...">
  </textarea>

  <div class="sticky-window__footer">
    <button class="btn-delete" (click)="deleteNote()" matTooltip="Delete note" matTooltipPosition="left">
      <mat-icon>delete</mat-icon>
    </button>
    <span class="saved-msg" *ngIf="savedIndicator">✓ Saved</span>
  </div>

  <div class="resize-handle" (mousedown)="startResize($event)"></div>
</div>
